import Tick from '../../../assets/images/shared/icons/quote-tick.svg';

const FeedbackConfirmation = () => (
  <div className="cef-feedback-form">
    <div className="cef-feedback-form__header cef-feedback-form__header--confirmation fl ai-fs">
      <img
        src={Tick}
        alt=""
        width="40"
        height="40"
        className="mr-075 cef-feedback__tick-icon"
      />
      <div>
        <p className="cef-feedback-form__heading cef-feedback-form__heading--small">
          Thank you for applying for our remote user panel
        </p>
        <p className="cef-feedback-form__text">
          We will shortly send you information on what will be involved in user
          testing and check if you would still like to opt in. There is no
          obligation to participate and you can leave the user panel at any
          time.
        </p>
      </div>
    </div>
  </div>
);

export default FeedbackConfirmation;
